// extracted by mini-css-extract-plugin
export default {"wrapper":"SearchBlock_wrapper__tOAVy"};